
 

 

 

 
class AuditLogSearchData 
{
    
        Id: string;
    
        AuditLogMessageCode: string;
    
        Message: string;
    
        EventDate: Date;
    
}
 
export default AuditLogSearchData;
 




